import jsPDF from "jspdf";
import "jspdf-autotable";

export const exportStaff = (staffList) => {
  const doc = new jsPDF();

  // Title
  doc.setFontSize(18);
  doc.text("Staff List", 14, 22);

  // Define table columns
  const tableColumn = ["Name", "Phone Number"];
  const tableRows = [];

  // Prepare rows
  staffList.forEach((staff) => {
    const name = staff.name || staff.nickname || "Unnamed";
    const phone = staff.phone || "N/A";
    tableRows.push([name, phone]);
  });

  // Add table to PDF
  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 30,
  });

  // Save PDF
  doc.save("staff_list.pdf");
};
